/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_16Inputs */



/**
* | output |
* | --- |
* | "Free 1:1 virtual training and support" |
*
* @param {Signup_Feature_Pro_16Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_16 = /** @type {((inputs?: Signup_Feature_Pro_16Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_16Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "de") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "it") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "es") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
	return /** @type {LocalizedString} */ ("Free 1:1 virtual training and support")
});